import React from 'react';

import { HomeNavbar, ProjectNavbar } from '@/app/Navbar';
import { useRouteChrome } from '@/shared/routing';

/** The navbar the route declares; keyed by project, so its state belongs to the project it showed. */
const NavbarRouter: React.FunctionComponent = (): JSX.Element => {
    const chrome = useRouteChrome();

    switch (chrome.navbar) {
        case 'project':
            return <ProjectNavbar key={chrome.projectId} projectId={chrome.projectId} />;
        case 'home':
            return <HomeNavbar />;
        case 'none':
            return <></>;
    }
};

export default NavbarRouter;
